import { Wording } from '@/types';

export const LOVE_WORDING_LV: Wording = {
  components_header_media_content: 'Audio',
  components_header_media_1: 'Meditācijas',
  components_header_media_2: 'Podcast',
  components_header_text1: 'Ceļveži',
  components_header_text2: 'Emuārs',
  components_header_members: 'Biedri',
  hero_text: 'Atklājiet mīlestību caur zvaigznēm',
  hero_button_text: 'Sāciet savu ceļojumu',
  components_ressources_section_title: 'MĪLESTĪBA UN ASTROLOĢIJA',
  components_ressources_subheader_text: 'Jūsu debesu rīku komplekts romantiskam ieskatam',
  components_ressources_span_text: 'Ienirstiet mūsu aplādes un rakstu pasaulē, kuru centrā ir mīlestība, zodiaka saderība un kosmiskā saikne. Neatkarīgi no tā, vai meklējat dvēseles radinieku skaidrību vai atšifrējat savus attiecību modeļus, mūsu resursi palīdzēs jums iegūt dziļāku izpratni caur zvaigznēm.',
  components_ressources_card_1_title: 'Zodiaka mīlestības sarunas',
  components_ressources_card_1_text: 'Izpētiet sirsnīgas aplādes epizodes, iedziļinoties katras zīmes emocionālajā valodā, mīlestības saderībā, kaislībā un personiskajā attiecību izaugsmē.',
  components_ressources_card_2_title: 'Mīlestības emuārs',
  components_ressources_card_2_text: 'Lasiet atziņas un pārdomas par to, kā katra zīme mīl, dziedina un savienojas. Mūsu emuārs ir jūsu ceļvedis astroloģiskai mīlestībai, sākot no sinastrijas līdz planētu romantikai.',
  components_ressources_link: 'Izpētiet tālāk',
  components_notes_and_google_title_1: 'Romantiskā astroloģija',
  components_notes_and_google_title_2: 'Mīlestības ieradumi',
  components_notes_and_google_title_3: 'Klausītāju mīlestības pārdomas',
  components_review_google_text: 'Ko saka mūsu klausītāji',
  media_content_section_title: 'MĪLESTĪBAS UN ZODIAKA PODCAST',
  media_content_section_subheader_text: 'Īsta saruna par kosmisko romantiku',
  text_media_1: 'Noskaņojieties dziļām, atklājošām epizodēm par astroloģiskiem sakritībām, emocionāliem modeļiem un romantisku dinamiku.',
  text_media_2: '',
  media_content_section_button_more: 'Klausieties tūlīt',
  text2_section_title: 'BLOGS',
  text2_section_subheader_text: 'Astroloģiski mīlas stāsti un atziņas',
  text2_section_button_more: 'Ielādēt vairāk',
  components_text1_section_title: 'CEĻVEIDI',
  components_text1_subheader_text: '',
  components_text1_span_text: '',
  components_text1_card_1_title: '',
  components_text1_card_1_text: '',
  components_text1_card_3_title: '',
  components_text1_card_3_text: '',
  components_text1_card_2_title: '',
  components_text1_card_2_text: '',
  components_text1_link: '',
  components_footer_text: 'Ļaujiet zvaigznēm vadīt jūsu mīlas stāstu',
  components_footer_info: 'Informācija',
  components_footer_registration_number: 'Reģistrācijas numurs',
  components_footer_legal: 'Juridisks',
  components_footer_terms: 'Noteikumi un nosacījumi',
  components_footer_privacy: 'Privātuma politika',
  button_load_more: 'Ielādēt vairāk',
  page_media_2_content_hero_text: '',
  page_media_content_menu_antistress: '',
  page_media_content_menu_mindfulness: '',
  page_media_content_menu_energyboost: '',
  page_media_content_menu_mantra: '',
  page_media_1_content_hero_text: 'Mīlestība un zodiaks: Podcast epizodes',
  page_media_content_menu_compatibility: 'Saderība',
  page_media_content_menu_love: 'Mīlestība',
  page_text1_hero_text: '',
  page_text1_section_title: '',
  page_text1_subheader_text: '',
  page_text2_hero_text: 'Izpētiet mīlestību caur astroloģiju',
  page_text2_section_title: 'Emuārs',
  page_text2_subheader_text: 'Raksti',
  enter_email_title: 'Lūdzu, ievadiet savu e-pastu, lai turpinātu',
  enter_email_placeholder_email: 'E-pasts',
  enter_email_button_enter: 'Ievadiet',
  components_login_success_text: 'Pieteikšanās veiksmīga!',
  components_card_link_media_content: 'Klausieties tūlīt',
  components_card_link_text2_content: 'Lasīt rakstus',
  components_card_link_text1_content: '',
  france: 'Francija',
  cyprus: 'Kipra',
  tag_podcast: 'Podcast',
  tag_meditation: 'Meditācija',
  page_media_content_menu_all: 'Visi',
};